/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Progress_LabelInputs */



/**
* | output |
* | --- |
* | "Publishing progress" |
*
* @param {Iconik_Publish_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_progress_label = /** @type {((inputs?: Iconik_Publish_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Progression de la publication")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veröffentlichungsfortschritt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progressi nella pubblicazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ход публикации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Progreso de publicación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出版进度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("出版の進捗状況")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकाशन प्रगति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Progresso da publicação")
	return /** @type {LocalizedString} */ ("Publishing progress")
});